module.exports = __webpack_public_path__ + "static/img/drcalc.70b3034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drcalc.png
// module id = 8plQ
// module chunks = 1